export default __webpack_public_path__ + "static/media/bg-5.0453080e.png";